export const menu = [
    // {en:'intro', cs:'Úvod'},
    {en:'place', cs: 'Kde nás najít'},
    {en: 'schedule', cs: 'Otevírací doba'},
    {en:'gallery', cs: 'Galerie'},
    {en: 'about', cs: 'O nás'},
    {en: 'contact', cs: 'Kontakt'},
]